export default "https://client.chat.ao.com/1289/beta/without-externals/assets/sounds/agentConnected.webm?b5374efbe1b38a27ab1d22288252a72f";